module.exports = __webpack_public_path__ + "static/media/AF.659b2076.svg";